/// <reference path="../svg.d.ts" />
import React from 'react';
import { getIconProps, IconProps } from '../utils';
import ReceiptSvg from '../assets/ui/receipt.svg?react';

export const ReceiptIcon: React.FC<IconProps> = props => {
  return <ReceiptSvg {...getIconProps(props)} />;
};
